/**
 * @fileoverview Generic file and upload constants used across the application.
 */
// 
/** Maximum allowed file size in bytes for file and photo uploads across the application (30MB). */
export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB in bytes

/** Maximum allowed file size in Megabytes. */
export const MAX_FILE_SIZE_MB = 30;
